import { useEffect, useState, useMemo } from 'react';
import { throttle } from 'app/libs/endash';

export default function useScrollScreenView(obj) {
	/*
		::: 스크린에 들어오면 stats 값이 true, 벗어나면 false

		onePlay: 최초 1회만 실행 후 이벤트 삭제
	*/
	const onePlay = obj?.onePlay;

	const [target, setTarget] = useState(null);
	const [plusPercent, setPlusPercent] = useState(0);
	const [state, setState] = useState(false);

	const removeFunc = (func) => {
		window.removeEventListener('scroll', func);
		window.removeEventListener('resize', func);
	};

	const onScroll = useMemo(
		() =>
			throttle(() => {
				if (!target?.current) return;
				// display:none 등으로 레이아웃에서 제외된 요소는 offsetParent가 null → 로딩하지 않음
				if (!target.current.offsetParent) return;

				const { pageYOffset, innerHeight } = window;
				const { offsetHeight } = target.current;
				const position = target.current.getBoundingClientRect().top;
				const plusPercentCal = offsetHeight * (plusPercent / 100);
				const screenView =
					pageYOffset >= position + pageYOffset - innerHeight - plusPercentCal &&
					pageYOffset <= position + pageYOffset + offsetHeight + plusPercentCal;
				if (onePlay) {
					if (screenView) {
						setState(true);
						removeFunc(onScroll);
					}
				} else {
					setState(screenView);
				}
			}, 200),
		[target, plusPercent, onePlay],
	);

	useEffect(() => {
		if (target?.current) {
			window.addEventListener('scroll', onScroll);
			window.addEventListener('resize', onScroll);
			onScroll();
		}
		return () => {
			removeFunc(onScroll);
		};
	}, [onScroll, target]);

	return {
		setTarget,
		setPlusPercent,
		state,
	};
}
